var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('tax-form',{attrs:{"loading":_vm.loading,"taxData":_vm.tax,"formErrors":_vm.formErrors},on:{"taxSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }